import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function Hero() {
  return <section className="relative pt-16 pb-20 px-6 lg:pt-24 lg:pb-28 overflow-hidden" data-id="element-139">
      {/* Subtle background decoration */}
      <div className="absolute top-0 left-0 w-full h-full bg-cream-dark opacity-30 -z-10 rounded-b-[100px] lg:rounded-b-[200px]" data-id="element-140"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-141">
        <FadeIn data-id="element-142">
          <div className="inline-flex items-center justify-center px-4 py-2 mb-6 rounded-full bg-sage/10 text-sage-dark font-medium text-sm tracking-wide uppercase" data-id="element-143">
            <span className="mr-2 text-lg" data-id="element-144">🌿</span>
            Sabiduría Natural
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brown-dark mb-6 leading-tight" data-id="element-145">
            LA BOTICA DE LA <br className="hidden md:block" data-id="element-146" />
            <span className="text-amber-dark italic" data-id="element-147">ABUELA MODERNA</span>
          </h1>
          <p className="text-xl md:text-2xl text-brown mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-148">
            Remedios de siempre con lo que encuentras hoy en el supermercado de
            USA.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-149">
          <div className="relative max-w-2xl mx-auto mb-12" data-id="element-150">
            <div className="absolute -inset-4 bg-amber/20 rounded-[2.5rem] blur-xl opacity-50" data-id="element-151"></div>
            <img src="https://cdn.magicpatterns.com/uploads/9a4vhTTwWmMtZeLT9KHqqv/heylloyd-image-1776220135630.png" alt="La Botica de la Abuela Moderna - Libro Digital" className="relative rounded-3xl shadow-2xl w-full object-cover border-4 border-white/50" data-id="element-152" />
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-153">
          <Button href="#comprar" className="w-full sm:w-auto text-lg md:text-xl px-10 py-5" data-id="element-154">
            Quiero mi copia ahora
          </Button>
          <p className="mt-4 text-sm text-brown-light" data-id="element-155">
            Descarga instantánea • 100% en Español
          </p>
        </FadeIn>
      </div>
    </section>;
}